<template>
  <span class="svg-ico-magnifier">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0267 17.8165C13.8838 20.4272 9.21128 20.2594 6.26502 17.3131C3.14083 14.1889 3.14083 9.12359 6.26502 5.9994C9.38921 2.8752 14.4545 2.8752 17.5787 5.9994C20.5232 8.94385 20.6926 13.6125 18.0869 16.7554L21.7067 20.3751C21.9996 20.668 21.9996 21.1429 21.7067 21.4358C21.4138 21.7287 20.9389 21.7287 20.646 21.4358L17.0267 17.8165ZM16.5181 16.2524C13.9797 18.7909 9.86409 18.7909 7.32568 16.2524C4.78727 13.714 4.78727 9.59846 7.32568 7.06006C9.86409 4.52165 13.9797 4.52165 16.5181 7.06006C19.0565 9.59846 19.0565 13.714 16.5181 16.2524Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
